// import React, { useEffect } from "react";
// import { useState } from "react";
// import { getSiteRefrence } from "../../../api/endpoints/refrences";
// import { authSelector } from "../../../store/selectors/index";
// import { useSelector } from "react-redux";
// import { message } from "antd";
// import "./style.css";

// export const ComponentToPrint = React.forwardRef((item, ref) => {
//   const { access_token } = useSelector(authSelector);
//   const [siteName, setSiteName] = useState();
//   const [siteAddress, setSiteAddress] = useState();
//   const [formattedDate, setFormattedDate] = useState("");

//   const [total, setTotal] = useState();
//   const [debitTotal, setDebitTotal] = useState();
//   const [openingCashTotal, setOpeningCashTotal] = useState();

//   console.log("printjs");
//   const [openingCashColumn, setOpeningCashColumn] = useState([]);
//   const [meterColumn, setMeterColumn] = useState([]);
//   const [dailyDipColumn, setDailyDipColumn] = useState([]);
//   const [lubeColumn, setLubeColumn] = useState([]);
//   const [lubePreviousColumn, setLubePreviousColumn] = useState([]);
//   const [lubeData, setLubeData] = useState([]);
//   const [purchaseColumn, setPurchaseColumn] = useState([]);
//   const [paymentColumn, setPaymentColumn] = useState([]);
//   const [receiptColumn, setReceiptColumn] = useState([]);
//   const [cardColumn, setCardColumn] = useState([]);
//   const [creditSaleColumn, setCreditSaleColumn] = useState([]);
//   const [sums, setSums] = useState({});
//   const [rateDiffColumn, setRateDiffColumn] = useState([]);
//   const [creditSaleRateWiseColumn, setCreditSaleRateWiseColumn] = useState([]);
//   const [expenseColumn, setExpenseColumn] = useState([]);
//   const [bankColumn, setBankColumn] = useState([]);
//   const [bankStatusColumn, setBankStatusColumn] = useState([]);
//   const [supplierColumn, setSupplierColumn] = useState([]);
//   const [supplierStatusColumn, setSupplierStatusColumn] = useState([]);
//   const [customerStatusColumn, setCustomerStatusColumn] = useState([]);
//   const [cardStatusColumn, setCardStatusColumn] = useState([]);
//   const [stockFuelStatusColumn, setStockFuelStatusColumn] = useState([]);
//   const [stockLubeStatusColumn, setStockLubeStatusColumn] = useState([]);
//   const [tankLorryStatusColumn, setTankLorryStatusColumn] = useState([]);

//   useEffect(() => {
//     const meterSaleItem = [];
//     const dailyDipItem = [];
//     const purchasesItem = [];
//     const lubePreviousItem = [];
//     const lubeItem = [];
//     const paymentItem = [];
//     const cardItem = [];
//     const creditSaleItem = [];
//     const receiptsItem = [];
//     const creditRateDiffItem = [];
//     const creditSaleRateWiseItem = [];
//     const expenseItem = [];
//     const bankItem = [];
//     const supplierItem = [];
//     const bankStatusItem = [];
//     const supplierStatusItem = [];
//     const customerStatusItem = [];
//     const cardStatusItem = [];
//     const stockFuelStatusItem = [];
//     const stockLubeStatusItem = [];
//     const tankLorryStatusItem = [];

//     const openingCashColumnItem = [];
//     const leftColumnItems = [];
//     const rightColumnItems = [];
//     const purchaseColumnItems = [];
//     const receiptColumnItems = [];

//     item.item.forEach((item) => {
//       console.log(item, "item");

//       if (item.printOrder === 0) {
//         openingCashColumnItem.push(item); // Use push to accumulate items
//       }
//       if (item.printOrder === 1) {
//         meterSaleItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 2) {
//         dailyDipItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 3) {
//         purchasesItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 4) {
//         lubePreviousItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 5) {
//         lubeItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 6) {
//         cardItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 7) {
//         receiptsItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 8) {
//         creditSaleItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 9) {
//         creditRateDiffItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 10) {
//         creditSaleRateWiseItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 11) {
//         expenseItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 12) {
//         bankItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 13) {
//         supplierItem.push(item); // UseItem push to accumulate items
//       }
//       if (item.printOrder === 15) {
//         paymentItem.push(item); // Use push to accumulate items
//       }
//       if (item.printOrder === 17) {
//         bankStatusItem.push(item); // Use push to accumulate items
//       }
//       if (item.printOrder === 18) {
//         supplierStatusItem.push(item); // Use push to accumulate items
//       }
//       if (item.printOrder === 19) {
//         customerStatusItem.push(item); // Use push to accumulate items
//       }
//       if (item.printOrder === 22) {
//         cardStatusItem.push(item); // Use push to accumulate items
//       }
//       if (item.printOrder === 25) {
//         stockFuelStatusItem.push(item); // Use push to accumulate items
//       }
//       if (item.printOrder === 26) {
//         stockLubeStatusItem.push(item); // Use push to accumulate items
//       }
//       if (item.printOrder === 27) {
//         tankLorryStatusItem.push(item); // Use push to accumulate items
//       }
//     });

//     // Set the state of leftColumn and rightColumn
//     setOpeningCashColumn(openingCashColumnItem);
//     setMeterColumn(meterSaleItem);
//     setDailyDipColumn(dailyDipItem);
//     setPurchaseColumn(purchasesItem);
//     setLubePreviousColumn(lubePreviousItem);
//     setLubeColumn(lubeItem);
//     setCardColumn(cardItem);
//     setReceiptColumn(receiptsItem);
//     setPaymentColumn(paymentItem);
//     setCreditSaleColumn(creditSaleItem);
//     setRateDiffColumn(creditRateDiffItem);
//     setCreditSaleRateWiseColumn(creditSaleRateWiseItem);
//     setExpenseColumn(expenseItem);
//     setBankColumn(bankItem);
//     setBankStatusColumn(bankStatusItem);
//     setSupplierStatusColumn(supplierStatusItem);
//     setCustomerStatusColumn(customerStatusItem);
//     setCardStatusColumn(cardStatusItem);
//     setStockFuelStatusColumn(stockFuelStatusItem);
//     setStockLubeStatusColumn(stockLubeStatusItem);
//     setTankLorryStatusColumn(tankLorryStatusItem);
//     setSupplierColumn(supplierItem);
//   }, [item.item]);

//   console.log(cardStatusColumn, "cardstatuss");

//   useEffect(() => {
//     // Calculate the total sum using reduce

//     const openCashSumcredit = openingCashColumn.reduce((accumulator, ele) => {
//       const openCashSumcreditTotal = parseFloat(ele.credit);
//       if (!isNaN(openCashSumcreditTotal) && isFinite(openCashSumcreditTotal)) {
//         return accumulator + openCashSumcreditTotal;
//       }
//       // Handle non-numeric values as 0
//       return accumulator;
//     }, 0);

//     const openCashSumdebit = openingCashColumn.reduce((accumulator, ele) => {
//       const openCashSumdebitTotal = parseFloat(ele.debit);
//       if (!isNaN(openCashSumdebitTotal) && isFinite(openCashSumdebitTotal)) {
//         return accumulator + openCashSumdebitTotal;
//       }
//       // Handle non-numeric values as 0
//       return accumulator;
//     }, 0);
//     console.log("credit", openCashSumcredit, openCashSumdebit, "debit");

//     // Update the state with the total sum

//     setOpeningCashTotal(
//       (parseFloat(openCashSumcredit) - parseFloat(openCashSumdebit)).toFixed(2)
//     );
//   }, [openingCashColumn, openingCashTotal]);

//   useEffect(() => {
//     const calculatedSums = {};

//     meterColumn.forEach((row) => {
//       const { itemCode, itemName, quantity, saleRate } = row;

//       if (!calculatedSums[itemCode]) {
//         calculatedSums[itemCode] = {
//           totalQuantity: 0,
//           totalAmount: 0,
//           itemName: itemName,
//         };
//       }

//       calculatedSums[itemCode].totalQuantity += quantity;
//       calculatedSums[itemCode].totalAmount += quantity * saleRate;
//     });

//     setSums(calculatedSums);
//   }, [meterColumn]);

//   useEffect(() => {
//     // Calculate the final balance for each itemCode
//     const combinedData = lubeColumn.map((lubeItem) => {
//       const prevItem = lubePreviousColumn.find(
//         (prev) => prev.itemCode === lubeItem.itemCode
//       );
//       const balanceQty = prevItem ? prevItem.balanceQty : 0;
//       const saleQuantity = lubeItem.quantity;
//       const saleRate = lubeItem.saleRate;
//       const finalBalance = balanceQty - saleQuantity;

//       return {
//         itemCode: lubeItem.itemCode,
//         itemName: lubeItem.itemName,
//         saleRate: saleRate,
//         preBalance: balanceQty,
//         saleQuantity: saleQuantity,
//         finalBalance: finalBalance,
//       };
//     });

//     setLubeData(combinedData);
//   }, [lubeColumn, lubePreviousColumn]);

//   const getName = async (e) => {
//     const result = await getSiteRefrence(access_token);
//     if (result.success) {
//       setSiteName(result.data.siteName);
//       setSiteAddress(result.data.siteAddress);
//     } else {
//       message.error(result.message);
//     }
//   };

//   let totalLubeSum = 0;
//   let totalLubeQtySum = 0;
//   lubeData.forEach((ele) => {
//     totalLubeSum += ele.saleRate * ele.saleQuantity;
//     totalLubeQtySum += ele.saleQuantity;
//   });

//   let salesAmountSum = 0;
//   for (const [key, value] of Object.entries(sums)) {
//     salesAmountSum += value.totalAmount;
//   }

//   let totalcreditRateDiffSum = 0;
//   rateDiffColumn.forEach((ele) => {
//     totalcreditRateDiffSum += ele.credit;
//   });

//   let totalSalesAmountSum =
//     salesAmountSum + totalLubeSum - totalcreditRateDiffSum;

//   let totalCardSum = 0;
//   cardColumn.forEach((ele) => {
//     totalCardSum += ele.debit;
//   });

//   let totalCreditSaleSum = 0;
//   creditSaleColumn.forEach((ele) => {
//     totalCreditSaleSum += ele.debit;
//   });

//   let totalReceivingSum = 0;
//   receiptColumn.forEach((ele) => {
//     totalReceivingSum += ele.credit;
//   });

//   let totalPaymentSum = 0;
//   paymentColumn.forEach((ele) => {
//     totalPaymentSum += ele.debit;
//   });

//   let totalExpenseSum = 0;
//   expenseColumn.forEach((ele) => {
//     totalExpenseSum += ele.debit;
//   });

//   let totalBankSum = 0;
//   bankColumn.forEach((ele) => {
//     totalBankSum += ele.debit;
//   });

//   let totalCustomerSum = 0;
//   customerStatusColumn.forEach((ele) => {
//     totalCustomerSum += ele.debit;
//   });

//   //Credit and Card Sale total
//   let netCreditSale = parseFloat(totalCreditSaleSum) + parseFloat(totalCardSum);

//   // Net Sale
//   let netSale = parseFloat(totalSalesAmountSum) - parseFloat(netCreditSale);

//   //Total Cash
//   let totalCash = 0;
//   totalCash =
//     parseFloat(openingCashTotal) +
//     parseFloat(netSale) +
//     parseFloat(totalReceivingSum);

//   let cashInHand =
//     parseFloat(totalCash) -
//     parseFloat(totalPaymentSum) -
//     parseFloat(totalExpenseSum) -
//     parseFloat(totalBankSum);

//   useEffect(() => {
//     getName();
//   });

//   useEffect(() => {
//     function formatDate(inputDate) {
//       const options = { year: "numeric", month: "long", day: "numeric" };
//       const formattedDate = new Date(inputDate).toLocaleDateString(
//         undefined,
//         options
//       );
//       return formattedDate;
//     }

//     const inputDate = meterColumn[0]?.enteredOn; // Use optional chaining to avoid errors if rightColumn[0] is undefined
//     if (inputDate) {
//       const formatted = formatDate(inputDate);
//       setFormattedDate(formatted); // Set the formatted date in the state
//     }
//   }, [meterColumn]); // Listen for changes in rightColumn

//   function formatValue(value) {
//     // Check if the value is negative
//     if (value < 0) {
//       // If it's negative, wrap it in parentheses
//       return `(${Math.abs(value)})`;
//     } else {
//       // If it's positive or zero, show it as is
//       return `${value}`;
//     }
//   }

//   let totalQuantity = 0;
//   let totalAmount = 0;
//   // let totalDebitbankStatusColumn = 0;
//   const totalDebitbankStatusColumn = bankStatusColumn.reduce(
//     (acc, ele) => acc + ele.debit,
//     0
//   );
//   const totalDebitSupplierStatusColumn = supplierStatusColumn.reduce(
//     (acc, ele) => acc + ele.debit,
//     0
//   );
//   const totalDebitCardStatusColumn = cardStatusColumn.reduce(
//     (acc, ele) => acc + ele.debit,
//     0
//   );

//   const totalDebitFuelStockStatusColumn = stockFuelStatusColumn.reduce(
//     (acc, ele) => acc + ele.debit,
//     0
//   );

//   const totalDebitLubeStockStatusColumn = stockLubeStatusColumn.reduce(
//     (acc, ele) => acc + ele.debit,
//     0
//   );

//   const totalDebitTankLorryStatusColumn = tankLorryStatusColumn.reduce(
//     (acc, ele) => acc + ele.debit,
//     0
//   );
//   const totalNetValue =
//     totalDebitLubeStockStatusColumn +
//     totalDebitFuelStockStatusColumn +
//     totalDebitCardStatusColumn +
//     totalDebitSupplierStatusColumn +
//     totalDebitbankStatusColumn +
//     cashInHand +
//     totalDebitTankLorryStatusColumn +
//     totalCustomerSum;
//   const formattedTotalNetValue = totalNetValue.toLocaleString("en-US", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

//   meterColumn.forEach((ele) => {
//     totalQuantity += parseFloat(ele.quantity);
//     totalAmount += parseFloat(ele.quantity) * parseFloat(ele.saleRate);
//   });

//   let itemTotals = {};

//   const [itemDipTotals, setItemDipTotals] = useState({});
//   useEffect(() => {
//     // Initialize itemDipTotals when dailyDipColumn changes
//     const totals = dailyDipColumn.reduce((acc, ele) => {
//       const itemCode = ele.itemCode;
//       acc[itemCode] = acc[itemCode] || {
//         openingQty: 0,
//         purchaseQty: 0,
//         saleQty: 0,
//         balanceQty: 0,
//         gainQty: 0,
//         closingQty: 0,
//       };

//       acc[itemCode].openingQty += parseFloat(ele.quantityOpening);
//       acc[itemCode].purchaseQty += parseFloat(ele.quantity);
//       acc[itemCode].saleQty += parseFloat(ele.balanceQty);
//       acc[itemCode].balanceQty +=
//         parseFloat(ele.quantityOpening) +
//         parseFloat(ele.quantity) -
//         parseFloat(ele.balanceQty);
//       acc[itemCode].gainQty +=
//         parseFloat(ele.quantityClosing) -
//         (parseFloat(ele.quantityOpening) +
//           parseFloat(ele.quantity) -
//           parseFloat(ele.balanceQty));
//       acc[itemCode].closingQty += parseFloat(ele.quantityClosing);

//       return acc;
//     }, {});

//     setItemDipTotals(totals);
//   }, [dailyDipColumn]);

//   return (
//     <div ref={ref}>
//       <div className="flex flex-col items-center justify-center">
//         <strong>
//           {" "}
//           <h1 style={{ fontSize: "30px" }}>{siteName}</h1>
//         </strong>
//         <strong>
//           {" "}
//           <h1 style={{ fontSize: "17px" }}>{siteAddress}</h1>
//         </strong>
//         <strong>
//           <h1 style={{ fontSize: "17px" }}>
//             Daily Sheet {formattedDate || "Loading..."}
//           </h1>
//         </strong>
//       </div>
//       <div className="page-break">
//          <div className="bg-white p-4 rounded mb-8">
//            <h2 className="text-2xl font-semibold mb-4">Meter Sale</h2>
//            <table className="w-full border-collapse">
//              {/* Table Headers */}
//              <thead>
//                <tr className="bg-gray-200">
//                  <th className="border p-2">Nozel Number</th>
//                  <th className="border p-2">Opening</th>
//                  <th className="border p-2">Ending</th>
//                  <th className="border p-2">Quantity</th>
//                  <th className="border p-2">Sale Rate</th>
//                  <th className="border p-2">Re Tank</th>
//                  <th className="border p-2">Amount</th>
//                </tr>
//              </thead>
//              {/* Table Body */}
//              <tbody>
//                {meterColumn.length > 0 &&
//                  meterColumn
//                    .sort((a, b) => a.nozelOrder - b.nozelOrder)
//                    .sort((a, b) => a.shift - b.shift)
//                    .map((ele, i) => {
//                      const rowAmount = (
//                        parseFloat(ele.quantity) * parseFloat(ele.saleRate)
//                      ).toFixed(2);

//                      if (!itemTotals[ele.itemCode]) {
//                        itemTotals[ele.itemCode] = {
//                          quantity: 0,
//                          amount: 0,
//                        };
//                      }

//                      itemTotals[ele.itemCode].quantity += parseFloat(
//                        ele.quantity
//                      );
//                      itemTotals[ele.itemCode].amount += parseFloat(rowAmount);

//                      return (
//                        <tr key={i} className="bg-white border-t">
//                          <td className="border p-2">{ele.nozelNumber}</td>
//                          <td className="border p-2">{ele.meterStarting}</td>
//                          <td className="border p-2">{ele.meterEnding}</td>
//                          <td className="border p-2">{ele.quantity}</td>
//                          <td className="border p-2">{ele.saleRate}</td>
//                          <td className="border p-2">{ele.meterCheck}</td>
//                          <td className="border p-2">{rowAmount}</td>
//                        </tr>
//                      );
//                    })}
//                     {Object.entries(itemTotals).map(
//                   ([itemCode, itemTotal], index) => (
//                     <tr
//                       key={index}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td></td>
//                       <td  className="px-6 py-4 text-right">
//                       <strong>{`Total`}</strong>
//                       {/* <strong>{`Total for Item ${itemCode}`}</strong> */}
//                       </td>
//                       <td className="px-6 py-4">
//                       {itemCode === "1" ? <strong>PMG</strong> : null}
//                       {itemCode === "2" ? <strong>HSD</strong> : null}
//                       {itemCode === "3" ? <strong>HOBC</strong> : null}
//                       {/* <strong>{itemTotal.openingQty.toFixed(2)}</strong> */}
//                     </td>
//                       <td className="px-6 py-4">
//                         <strong>{itemTotal.quantity.toFixed(2)}</strong>
//                       </td>
//                       <td></td>
//                       <td className="px-6 py-4">
//                         <strong>{itemTotal.amount.toFixed(2)}</strong>
//                       </td>
//                     </tr>
//                   )
//                 )}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td colSpan="2" className="px-6 py-4 text-right">
//                     <strong>Total ALL</strong>
//                   </td>
//                   <td></td>
//                   <td className="px-6 py-4">
//                     <strong>{totalQuantity.toFixed(2)}</strong>
//                   </td>
//                   <td></td>
//                   <td className="px-6 py-4">
//                     <strong>{totalAmount.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//              </tbody>
//            </table>
//          </div>
//        </div>

//       <div className="flex pl-2 pr-2">
//         <div className="w-2/4 ">
//           <table>
//             <thead>
//               <tr className=" bg-white   dark:border-gray-700">
//                 <th className="px-6 py-4">Daily DIp</th>
//               </tr>
//             </thead>
//             <thead>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <th className="px-6 py-4">Item Code</th>
//                 <th className="px-6 py-4">Tank Number</th>
//                 <th className="px-6 py-4">Opening Dip</th>
//                 <th className="px-6 py-4">Opening Qty</th>
//                 <th className="px-6 py-4">Purchase</th>
//                 <th className="px-6 py-4">Sale</th>
//                 <th className="px-6 py-4">Balance</th>
//                 <th className="px-6 py-4">Gain</th>
//                 <th className="px-6 py-4">Closing Dip</th>
//                 <th className="px-6 py-4">Closing Qty</th>
//               </tr>
//             </thead>
//             <tbody className="bg-white">
//               {dailyDipColumn.length > 0 &&
//                 dailyDipColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       {/* Your existing columns */}
//                       <td className="px-6 py-4">{ele.itemCode}</td>
//                       <td className="px-6 py-4">{ele.tankNumber}</td>
//                       <td className="px-6 py-4">{ele.mmOpening}</td>
//                       <td className="px-6 py-4">{ele.quantityOpening}</td>
//                       <td className="px-6 py-4">{ele.quantity}</td>
//                       <td className="px-6 py-4">{ele.balanceQty}</td>
//                       <td className="px-6 py-4">
//                         {(
//                           ele.quantityOpening +
//                           ele.quantity -
//                           ele.balanceQty
//                         ).toFixed(2)}
//                       </td>
//                       <td className="px-6 py-4">
//                         {(
//                           ele.quantityClosing -
//                           (ele.quantityOpening + ele.quantity - ele.balanceQty)
//                         ).toFixed(2)}
//                       </td>
//                       <td className="px-6 py-4">{ele.mmClosing}</td>
//                       <td className="px-6 py-4">{ele.quantityClosing}</td>
//                     </tr>
//                   );
//                 })}
//               {/* New row for displaying item-wise totals */}
//               {Object.entries(itemDipTotals).map(
//                 ([itemCode, itemTotal], index) => (
//                   <tr
//                     key={index}
//                     className="bg-white border-2  dark:border-gray-700"
//                   >
//                     <td colSpan="3" className="px-6 py-4 text-right">
//                       <strong>{`Total for Item ${itemCode}`}</strong>
//                     </td>
//                     {/* Add columns for each total you want to display */}
//                     <td className="px-6 py-4">
//                       {itemCode === "1" ? <strong>PMG</strong> : null}
//                       {itemCode === "2" ? <strong>HSD</strong> : null}
//                       {itemCode === "3" ? <strong>HOBC</strong> : null}
//                       {/* <strong>{itemTotal.openingQty.toFixed(2)}</strong> */}
//                     </td>
//                     <td className="px-6 py-4">
//                       {/* <strong>{itemTotal.purchaseQty.toFixed(2)}</strong> */}
//                     </td>
//                     <td className="px-6 py-4">
//                       {/* <strong>{itemTotal.saleQty.toFixed(2)}</strong> */}
//                     </td>
//                     <td className="px-6 py-4">
//                       {/* <strong>{itemTotal.balanceQty.toFixed(2)}</strong> */}
//                     </td>
//                     <td className="px-6 py-4">
//                       <strong>{itemTotal.gainQty.toFixed(2)}</strong>
//                     </td>
//                     <td className="px-6 py-4">
//                       {/* <strong>{itemTotal.closingQty.toFixed(2)}</strong> */}
//                     </td>
//                   </tr>
//                 )
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       {purchaseColumn.length > 0 ? (
//         <div className="w-2/4 ">
//           <table>
//             <thead>
//               <tr className=" bg-white   dark:border-gray-700">
//                 <th className="px-6 py-4">Purchase</th>
//               </tr>
//             </thead>
//             <thead>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <th className="px-6 py-4">V.No</th>
//                 <th className="px-6 py-4">Item Code</th>
//                 <th className="px-6 py-4">Item Name</th>
//                 <th className="px-6 py-4">Supplier Name</th>
//                 <th className="px-6 py-4">Quantity</th>
//                 <th className="px-6 py-4">Amount</th>
//               </tr>
//             </thead>
//             <tbody>
//               {purchaseColumn.length > 0 &&
//                 purchaseColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.purchaseVoucherNo}</td>
//                       <td className="px-6 py-4">{ele.itemCode}</td>
//                       <td className="px-6 py-4">{ele.itemName}</td>
//                       <td className="px-6 py-4">{ele.partyName}</td>
//                       <td className="px-6 py-4">{ele.quantity}</td>
//                       <td className="px-6 py-4">{ele.debit}</td>
//                     </tr>
//                   );
//                 })}
//               {/* New row for displaying totals */}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <div></div>
//       )}
//       <div className="flex pl-2 pr-2">
//         {lubeData.length > 0 ? (
//           <div className="w-2/4 ">
//             <table>
//               <thead>
//                 <tr className=" bg-white   dark:border-gray-700">
//                   <th className="px-6 py-4">Lube</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">Item Code</th>
//                   <th className="px-6 py-4">Item Name</th>
//                   <th className="px-6 py-4">Opening Balance</th>
//                   <th className="px-6 py-4">Sale Quantity</th>
//                   <th className="px-6 py-4">Sale Rate</th>
//                   <th className="px-6 py-4">Amount</th>
//                   <th className="px-6 py-4">Closing Balance</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {lubeData.length > 0 &&
//                   lubeData.map((ele, i) => {
//                     return (
//                       <tr
//                         key={i}
//                         className="bg-white border-2  dark:border-gray-700"
//                       >
//                         <td className="px-6 py-4">{ele.itemCode}</td>
//                         <td className="px-6 py-4">{ele.itemName}</td>
//                         <td className="px-6 py-4">{ele.preBalance}</td>
//                         <td className="px-6 py-4">{ele.saleQuantity}</td>
//                         <td className="px-6 py-4">{ele.saleRate}</td>
//                         <td className="px-6 py-4">
//                           {ele.saleRate * ele.saleQuantity}
//                         </td>
//                         <td className="px-6 py-4">{ele.finalBalance}</td>
//                       </tr>
//                     );
//                   })}
//                 {/* New row for displaying totals */}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalLubeSum.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>
//       <div className="flex pl-2 pr-2">
//         {cardColumn.length > 0 ? (
//           <div className="w-2/4 ">
//             <table>
//               <thead>
//                 <tr className=" bg-white   dark:border-gray-700">
//                   <th className="px-6 py-4">Cards</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">ID</th>
//                   <th className="px-6 py-4">Name</th>
//                   <th className="px-6 py-4">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {cardColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.partyId}</td>
//                       <td className="px-6 py-4">{ele.partyName}</td>
//                       <td className="px-6 py-4">{ele.debit}</td>
//                     </tr>
//                   );
//                 })}
//                 {/* New row for displaying totals */}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalCardSum.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>

//       <div className="flex pl-2 pr-2">
//         {creditSaleRateWiseColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className=" bg-white   dark:border-gray-700">
//                   <th className="px-6 py-4">Credit Sale Rate Wise</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">Item Name</th>
//                   <th className="px-6 py-4">Sale Rate</th>
//                   <th className="px-6 py-4">Quantity</th>
//                   <th className="px-6 py-4">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {creditSaleRateWiseColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.itemName}</td>
//                       <td className="px-6 py-4">{ele.saleRate}</td>
//                       <td className="px-6 py-4">{ele.quantity}</td>
//                       <td className="px-6 py-4">{ele.debit}</td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>

//       <div className="flex pl-2 pr-2">
//         {paymentColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className=" bg-white   dark:border-gray-700">
//                   <th className="px-6 py-4">Payments</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">V.No.</th>
//                   <th className="px-6 py-4">A/C No.</th>
//                   <th className="px-6 py-4">A/C Name</th>
//                   <th className="px-6 py-4">GL Code</th>
//                   <th className="px-6 py-4">GL Description</th>
//                   <th className="px-6 py-4">Description</th>
//                   <th className="px-6 py-4">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paymentColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.voucherNumber}</td>
//                       <td className="px-6 py-4">{ele.partyId}</td>
//                       <td className="px-6 py-4">{ele.partyName}</td>
//                       <td className="px-6 py-4">{ele.generalLedgerCode}</td>
//                       <td className="px-6 py-4">
//                         {ele.generalLedgerDescription}
//                       </td>
//                       <td className="px-6 py-4">{ele.description}</td>
//                       <td className="px-6 py-4">{ele.debit}</td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalPaymentSum.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>

//       <div className="flex pl-2 pr-2">
//         {expenseColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className=" bg-white   dark:border-gray-700">
//                   <th className="px-6 py-4">Expenses</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">V.No.</th>
//                   <th className="px-6 py-4">A/C No.</th>
//                   <th className="px-6 py-4">A/C Name</th>
//                   <th className="px-6 py-4">GL Code</th>
//                   <th className="px-6 py-4">GL Description</th>
//                   <th className="px-6 py-4">Description</th>
//                   <th className="px-6 py-4">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {expenseColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.voucherNumber}</td>
//                       <td className="px-6 py-4">{ele.partyId}</td>
//                       <td className="px-6 py-4">{ele.partyName}</td>
//                       <td className="px-6 py-4">{ele.generalLedgerCode}</td>
//                       <td className="px-6 py-4">
//                         {ele.generalLedgerDescription}
//                       </td>
//                       <td className="px-6 py-4">{ele.description}</td>
//                       <td className="px-6 py-4">{ele.debit}</td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalExpenseSum.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>

//       <div className="flex pl-2 pr-2">
//         {bankColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className=" bg-white   dark:border-gray-700">
//                   <th className="px-6 py-4">Bank</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">V.No.</th>
//                   <th className="px-6 py-4">GL Code</th>
//                   <th className="px-6 py-4">GL Description</th>
//                   <th className="px-6 py-4">Description</th>
//                   <th className="px-6 py-4">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {bankColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.voucherNumber}</td>
//                       <td className="px-6 py-4">{ele.generalLedgerCode}</td>
//                       <td className="px-6 py-4">
//                         {ele.generalLedgerDescription}
//                       </td>
//                       <td className="px-6 py-4">{ele.description}</td>
//                       <td className="px-6 py-4">{ele.debit}</td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalBankSum.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>

//       <div className="flex pl-2 pr-2">
//         {supplierColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className=" bg-white   dark:border-gray-700">
//                   <th className="px-6 py-4">Supplier Payments</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">V.No.</th>
//                   <th className="px-6 py-4">Party Id</th>
//                   <th className="px-6 py-4">Party Name</th>
//                   <th className="px-6 py-4">Description</th>
//                   <th className="px-6 py-4">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {supplierColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.voucherNumber}</td>
//                       <td className="px-6 py-4">{ele.partyId}</td>
//                       <td className="px-6 py-4">{ele.partyName}</td>
//                       <td className="px-6 py-4">{ele.description}</td>
//                       <td className="px-6 py-4">{ele.debit}</td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>

//       <div className="flex pl-2 pr-2">
//         {receiptColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className=" bg-white   dark:border-gray-700">
//                   <th className="px-6 py-4">Receivings</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">V.No.</th>
//                   <th className="px-6 py-4">A/C No.</th>
//                   <th className="px-6 py-4">A/C Name</th>
//                   <th className="px-6 py-4">GL Code</th>
//                   <th className="px-6 py-4">GL Description</th>
//                   <th className="px-6 py-4">Description</th>
//                   <th className="px-6 py-4">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {receiptColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.voucherNumber}</td>
//                       <td className="px-6 py-4">{ele.partyId}</td>
//                       <td className="px-6 py-4">{ele.partyName}</td>
//                       <td className="px-6 py-4">{ele.generalLedgerCode}</td>
//                       <td className="px-6 py-4">
//                         {ele.generalLedgerDescription}
//                       </td>
//                       <td className="px-6 py-4">{ele.description}</td>
//                       <td className="px-6 py-4">{ele.credit}</td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>

//       <div className="flex ">
//         <div className="salesWidth p-2">
//           <table>
//             <thead>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <th className="px-6 py-4">Sales</th>
//                 <th className="px-6 py-4">Quantity</th>
//                 <th className="px-6 py-4">Amount</th>
//               </tr>
//             </thead>
//             {Object.entries(sums).map(([key, value]) => (
//               <tbody key={key}>
//                 <tr class="bg-white border-2  dark:border-gray-700">
//                   <td class="px-6 py-4">{value.itemName}</td>
//                   <td class="px-6 py-4">{value.totalQuantity.toFixed(2)}</td>
//                   <td class="px-6 py-4">{value.totalAmount.toFixed(2)}</td>
//                 </tr>
//               </tbody>
//             ))}
//             <tbody>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">Lube</td>
//                 <td className="px-6 py-4">{totalLubeQtySum.toFixed(2)}</td>
//                 <td className="px-6 py-4">{totalLubeSum.toFixed(2)}</td>
//               </tr>
//               {rateDiffColumn.length > 0 &&
//                 rateDiffColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">Rate Diff</td>
//                       <td className="px-6 py-4"></td>
//                       <td className="px-6 py-4">{ele.credit}</td>
//                     </tr>
//                   );
//                 })}

//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   <strong>Total </strong>
//                 </td>
//                 <td className="px-6 py-4"></td>
//                 <td className="px-6 py-4" colSpan="2">
//                   <strong>{totalSalesAmountSum.toFixed(2)}</strong>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//         <div className="salesWidth p-2">
//           <table>
//             <thead>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <th className="px-6 py-4">Credits</th>
//                 <th className="px-6 py-4">Amount</th>
//               </tr>
//             </thead>

//             <tbody>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">Credit Cards</td>
//                 <td className="px-6 py-4">{totalCardSum.toFixed(2)}</td>
//               </tr>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">Credit Sale</td>
//                 <td className="px-6 py-4">{totalCreditSaleSum.toFixed(2)}</td>
//               </tr>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   <strong>Total </strong>
//                 </td>
//                 <td className="px-6 py-4" colSpan="2">
//                   <strong>{netCreditSale.toFixed(2)}</strong>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>
//       <div className="flex flex-col justify-center items-center">
//         <div>
//           <strong>Cash Summary</strong>
//         </div>
//         <div className="salesWidth p-2">
//           <table>
//             <thead>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 {/* <th className="px-6 py-4">Credits</th>
//                 <th className="px-6 py-4">Amount</th> */}
//               </tr>
//             </thead>

//             <tbody>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   {" "}
//                   <strong> Opening Cash </strong>
//                 </td>
//                 <td className="px-6 py-4">{openingCashTotal}</td>
//               </tr>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   {" "}
//                   <strong>Net Sales</strong>
//                 </td>
//                 <td className="px-6 py-4">
//                   {netSale.toFixed(2)}
//                   {/* {totalSalesAmountSum.toFixed(2) - totalCardSum.toFixed(2)}{" "} */}
//                 </td>
//               </tr>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   <strong>Receivings</strong>
//                 </td>
//                 <td className="px-6 py-4">{totalReceivingSum.toFixed(2)}</td>
//               </tr>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   <strong>Total Cash</strong>
//                 </td>
//                 <td className="px-6 py-4">
//                   {parseFloat(totalCash).toFixed(2)}
//                 </td>
//               </tr>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   <strong>Expense</strong>
//                 </td>
//                 <td className="px-6 py-4">
//                   {parseFloat(totalExpenseSum).toFixed(2)}
//                 </td>
//               </tr>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   <strong>Bank Deposit</strong>
//                 </td>
//                 <td className="px-6 py-4">
//                   {parseFloat(totalBankSum).toFixed(2)}
//                 </td>
//               </tr>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   <strong>Payments</strong>
//                 </td>
//                 <td className="px-6 py-4">
//                   {parseFloat(totalPaymentSum).toFixed(2)}
//                 </td>
//               </tr>
//               <tr className="bg-white border-2  dark:border-gray-700">
//                 <td className="px-6 py-4">
//                   <strong>Cash In Hand</strong>
//                 </td>
//                 <td className="px-6 py-4">
//                   {parseFloat(cashInHand).toFixed(2)}
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div className="flex pl-2 pr-2">
//         {bankStatusColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className="bg-white  dark:border-gray-700">
//                   <th className="px-6 py-4">Bank Status</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">Name</th>
//                   <th className="px-6 py-4">Receivable</th>
//                   <th className="px-6 py-4">Payable</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {bankStatusColumn.map((ele, i) => {
//                   //  const positiveDebit = ele.debit >= 0 ? ele.debit : 0;
//                   //  const negativeDebit = ele.debit < 0 ? -ele.debit : 0;
//                   //  const totalDebitbankStatusColumn = positiveDebit + negativeDebit;
//                   // Accumulate the total debit
//                   // totalDebitbankStatusColumn += ele.debit;
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">
//                         {ele.generalLedgerDescription}
//                       </td>
//                       <td className="px-6 py-4">
//                         {ele.debit >= 0 ? ele.debit : 0}
//                       </td>
//                       <td className="px-6 py-4">
//                         {ele.debit < 0 ? -ele.debit : 0}
//                       </td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalDebitbankStatusColumn.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>
//       <div className="flex pl-2 pr-2">
//         {cardStatusColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className="bg-white  dark:border-gray-700">
//                   <th className="px-6 py-4">Card Status</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">Name</th>
//                   <th className="px-6 py-4">Receivable</th>
//                   <th className="px-6 py-4">Payable</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {cardStatusColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.partyName}</td>
//                       <td className="px-6 py-4">
//                         {ele.debit >= 0 ? ele.debit : 0}
//                       </td>
//                       <td className="px-6 py-4">
//                         {ele.debit < 0 ? -ele.debit : 0}
//                       </td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalDebitCardStatusColumn.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>
//       <div className="flex pl-2 pr-2">
//         {supplierStatusColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className="bg-white  dark:border-gray-700">
//                   <th className="px-6 py-4">Supplier Status</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">Name</th>
//                   <th className="px-6 py-4">Receivable</th>
//                   <th className="px-6 py-4">Payable</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {supplierStatusColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.partyName}</td>
//                       <td className="px-6 py-4">
//                         {ele.debit >= 0 ? ele.debit : 0}
//                       </td>
//                       <td className="px-6 py-4">
//                         {ele.debit < 0 ? -ele.debit : 0}
//                       </td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalDebitSupplierStatusColumn.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>
//       <div className="flex pl-2 pr-2">
//         {stockFuelStatusColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className="bg-white  dark:border-gray-700">
//                   <th className="px-6 py-4">Stock Status</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">Item Name</th>
//                   <th className="px-6 py-4">Quantity</th>
//                   <th className="px-6 py-4">Rate</th>
//                   <th className="px-6 py-4">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {stockFuelStatusColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       <td className="px-6 py-4">{ele.itemName}</td>
//                       <td className="px-6 py-4">{ele.quantity}</td>
//                       <td className="px-6 py-4">{ele.purchaseRate}</td>
//                       <td className="px-6 py-4">{ele.debit}</td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Fuel Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>
//                       {totalDebitFuelStockStatusColumn.toFixed(2)}
//                     </strong>
//                   </td>
//                 </tr>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Lubricants:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>
//                       {totalDebitLubeStockStatusColumn.toFixed(2)}
//                     </strong>
//                   </td>
//                 </tr>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>
//                       {(
//                         Number(totalDebitLubeStockStatusColumn) +
//                         Number(totalDebitFuelStockStatusColumn)
//                       ).toFixed(2)}
//                     </strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//             {/* <table>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <th className="px-6 py-4">Net Value</th>
//                   <th className="px-6 py-4"></th>
//                   <th className="px-6 py-4"></th>
//                   <th className="px-6 py-4">{formattedTotalNetValue}</th>
//                 </tr>
//               </thead>
//             </table> */}
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>

//       <div className="flex pl-2 pr-2">
//         {tankLorryStatusColumn.length > 0 ? (
//           <div className="w-2/4">
//             <table>
//               <thead>
//                 <tr className="bg-white  dark:border-gray-700">
//                   <th className="px-6 py-4">Tank Lorry Status</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   {/* <th className="px-6 py-4">VNO</th> */}
//                   <th className="px-6 py-4">Description</th>
//                   {/* <th className="px-6 py-4">Item Name</th>
//                   <th className="px-6 py-4">Quantity</th>
//                   <th className="px-6 py-4">Rate</th> */}
//                   <th className="px-6 py-4">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tankLorryStatusColumn.map((ele, i) => {
//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       {/* <td className="px-6 py-4">{ele.voucherNumber}</td> */}
//                       <td className="px-6 py-4">{ele.itemDescription}</td>
//                       {/* <td className="px-6 py-4">{ele.itemName}</td>
//                       <td className="px-6 py-4">{ele.quantity}</td>
//                       <td className="px-6 py-4">{ele.purchaseRate}</td> */}
//                       <td className="px-6 py-4">{ele.debit}</td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Fuel Total:</strong>
//                   </td>
//                   {/* <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td>
//                   <td className="px-6 py-4"></td> */}
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>
//                       {totalDebitTankLorryStatusColumn.toFixed(2)}
//                     </strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div></div>
//         )}
//       </div>

//       <div className="flex pl-2 pr-2">
//         {(creditSaleColumn.length > 0 || customerStatusColumn.length > 0) && (
//           <div className="w-3/4">
//             <table>
//               <thead>
//                 <tr className=" bg-white  dark:border-gray-700">
//                   <th className="px-6 py-4">Credit Sale & Customer Status</th>
//                 </tr>
//               </thead>
//               <thead>
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   {/* <th className="px-6 py-4">A/C No.</th> */}
//                   <th className="px-6 py-4">A/C Name</th>
//                   <th className="px-6 py-4">To Day</th>
//                   <th className="px-6 py-4">Balance</th>
//                   {/* <th className="px-6 py-4">Receivable</th> */}
//                 </tr>
//               </thead>
//               <tbody>
//                 {creditSaleColumn.map((creditSale, i) => {
//                   // Find the corresponding customerStatus element based on partyId
//                   const customerStatus = customerStatusColumn.find(
//                     (customer) => customer.partyId === creditSale.partyId
//                   );

//                   return (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       {/* <td className="px-6 py-4">{creditSale.partyId}</td> */}
//                       <td className="px-6 py-4">{creditSale.partyName}</td>
//                       <td className="px-6 py-4">{creditSale.debit}</td>
//                       <td className="px-6 py-4">
//                         {customerStatus?.debit ?? ""}
//                       </td>
//                     </tr>
//                   );
//                 })}

//                 {customerStatusColumn
//                   .filter(
//                     (customer) =>
//                       !creditSaleColumn.some(
//                         (creditSale) => creditSale.partyId === customer.partyId
//                       )
//                   )
//                   .map((customerStatus, i) => (
//                     <tr
//                       key={i}
//                       className="bg-white border-2  dark:border-gray-700"
//                     >
//                       {/* <td className="px-6 py-4">{customerStatus.partyId}</td> */}
//                       <td className="px-6 py-4">{customerStatus.partyName}</td>
//                       <td className="px-6 py-4"></td>
//                       <td className="px-6 py-4">
//                         {customerStatus.debit < 0
//                           ? `(${Math.abs(customerStatus.debit)})`
//                           : customerStatus.debit}
//                       </td>
//                     </tr>
//                   ))}
//                 <tr className="bg-white border-2  dark:border-gray-700">
//                   <td className="px-6 py-4">
//                     <strong>Total:</strong>
//                   </td>

//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalCreditSaleSum.toFixed(2)}</strong>
//                   </td>
//                   <td className="px-6 py-4">
//                     {" "}
//                     <strong>{totalCustomerSum.toFixed(2)}</strong>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//       <div className="w-2/5">
//         <table>
//           <thead>
//             <tr className="bg-white border-2  dark:border-gray-700">
//               <th className="px-6 py-4">Net Value</th>
//               <th className="px-6 py-4"></th>
//               <th className="px-6 py-4"></th>
//               <th className="px-6 py-4">{formattedTotalNetValue}</th>
//             </tr>
//           </thead>
//         </table>
//       </div>
//     </div>
//   );
// });

import React, { useEffect } from "react";
import { useState } from "react";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import "./style.css";

export const ComponentToPrint = React.forwardRef((item, ref) => {
  const { access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [formattedDate, setFormattedDate] = useState("");

  const [total, setTotal] = useState();
  const [debitTotal, setDebitTotal] = useState();
  const [openingCashTotal, setOpeningCashTotal] = useState();

  const [openingCashColumn, setOpeningCashColumn] = useState([]);
  const [meterColumn, setMeterColumn] = useState([]);
  const [dailyDipColumn, setDailyDipColumn] = useState([]);
  const [lubeColumn, setLubeColumn] = useState([]);
  const [lubePreviousColumn, setLubePreviousColumn] = useState([]);
  const [lubeData, setLubeData] = useState([]);
  const [purchaseColumn, setPurchaseColumn] = useState([]);
  const [paymentColumn, setPaymentColumn] = useState([]);
  const [receiptColumn, setReceiptColumn] = useState([]);
  const [cardColumn, setCardColumn] = useState([]);
  const [creditSaleColumn, setCreditSaleColumn] = useState([]);
  const [sums, setSums] = useState({});
  const [rateDiffColumn, setRateDiffColumn] = useState([]);
  const [creditSaleRateWiseColumn, setCreditSaleRateWiseColumn] = useState([]);
  const [expenseColumn, setExpenseColumn] = useState([]);
  const [bankColumn, setBankColumn] = useState([]);
  const [bankStatusColumn, setBankStatusColumn] = useState([]);
  const [supplierColumn, setSupplierColumn] = useState([]);
  const [supplierStatusColumn, setSupplierStatusColumn] = useState([]);
  const [customerStatusColumn, setCustomerStatusColumn] = useState([]);
  const [cardStatusColumn, setCardStatusColumn] = useState([]);
  const [stockFuelStatusColumn, setStockFuelStatusColumn] = useState([]);
  const [stockLubeStatusColumn, setStockLubeStatusColumn] = useState([]);
  const [tankLorryStatusColumn, setTankLorryStatusColumn] = useState([]);
  const [bulkStockStatusColumn, setBulkStockStatusColumn] = useState([]);

  useEffect(() => {
    const meterSaleItem = [];
    const dailyDipItem = [];
    const purchasesItem = [];
    const lubePreviousItem = [];
    const lubeItem = [];
    const paymentItem = [];
    const cardItem = [];
    const creditSaleItem = [];
    const receiptsItem = [];
    const creditRateDiffItem = [];
    const creditSaleRateWiseItem = [];
    const expenseItem = [];
    const bankItem = [];
    const supplierItem = [];
    const bankStatusItem = [];
    const supplierStatusItem = [];
    const customerStatusItem = [];
    const cardStatusItem = [];
    const stockFuelStatusItem = [];
    const stockLubeStatusItem = [];
    const tankLorryStatusItem = [];
    const bulkStockStatusItem = [];

    const openingCashColumnItem = [];
    const leftColumnItems = [];
    const rightColumnItems = [];
    const purchaseColumnItems = [];
    const receiptColumnItems = [];

    item.item.forEach((item) => {
      // console.log(item, "item");

      if (item.printOrder === 0) {
        openingCashColumnItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 1) {
        meterSaleItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 2) {
        dailyDipItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 3) {
        purchasesItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 4) {
        lubePreviousItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 5) {
        lubeItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 6) {
        cardItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 7) {
        receiptsItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 8) {
        creditSaleItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 9) {
        creditRateDiffItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 10) {
        creditSaleRateWiseItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 11) {
        expenseItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 12) {
        bankItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 13) {
        supplierItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 15) {
        paymentItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 17) {
        bankStatusItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 18) {
        supplierStatusItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 19) {
        customerStatusItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 22) {
        cardStatusItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 25) {
        stockFuelStatusItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 26) {
        stockLubeStatusItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 27) {
        tankLorryStatusItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 31) {
        bulkStockStatusItem.push(item); // Use push to accumulate items
      }
    });

    // Set the state of leftColumn and rightColumn
    setOpeningCashColumn(openingCashColumnItem);
    setMeterColumn(meterSaleItem);
    setDailyDipColumn(dailyDipItem);
    setPurchaseColumn(purchasesItem);
    setLubePreviousColumn(lubePreviousItem);
    setLubeColumn(lubeItem);
    setCardColumn(cardItem);
    setReceiptColumn(receiptsItem);
    setPaymentColumn(paymentItem);
    setCreditSaleColumn(creditSaleItem);
    setRateDiffColumn(creditRateDiffItem);
    setCreditSaleRateWiseColumn(creditSaleRateWiseItem);
    setExpenseColumn(expenseItem);
    setBankColumn(bankItem);
    setBankStatusColumn(bankStatusItem);
    setSupplierStatusColumn(supplierStatusItem);
    setCustomerStatusColumn(customerStatusItem);
    setCardStatusColumn(cardStatusItem);
    setStockFuelStatusColumn(stockFuelStatusItem);
    setStockLubeStatusColumn(stockLubeStatusItem);
    setTankLorryStatusColumn(tankLorryStatusItem);
    setBulkStockStatusColumn(bulkStockStatusItem);
    setSupplierColumn(supplierItem);
  }, [item.item]);

  console.log(cardStatusColumn, "cardstatuss");

  useEffect(() => {
    // Calculate the total sum using reduce

    const openCashSumcredit = openingCashColumn.reduce((accumulator, ele) => {
      const openCashSumcreditTotal = parseFloat(ele.credit);
      if (!isNaN(openCashSumcreditTotal) && isFinite(openCashSumcreditTotal)) {
        return accumulator + openCashSumcreditTotal;
      }
      // Handle non-numeric values as 0
      return accumulator;
    }, 0);

    const openCashSumdebit = openingCashColumn.reduce((accumulator, ele) => {
      const openCashSumdebitTotal = parseFloat(ele.debit);
      if (!isNaN(openCashSumdebitTotal) && isFinite(openCashSumdebitTotal)) {
        return accumulator + openCashSumdebitTotal;
      }
      // Handle non-numeric values as 0
      return accumulator;
    }, 0);
    console.log("credit", openCashSumcredit, openCashSumdebit, "debit");

    // Update the state with the total sum

    setOpeningCashTotal(
      (parseFloat(openCashSumcredit) - parseFloat(openCashSumdebit)).toFixed(2)
    );
  }, [openingCashColumn, openingCashTotal]);

  useEffect(() => {
    const calculatedSums = {};

    meterColumn.forEach((row) => {
      const { itemCode, itemName, quantity, saleRate } = row;

      if (!calculatedSums[itemCode]) {
        calculatedSums[itemCode] = {
          totalQuantity: 0,
          totalAmount: 0,
          itemName: itemName,
        };
      }

      calculatedSums[itemCode].totalQuantity += quantity;
      calculatedSums[itemCode].totalAmount += quantity * saleRate;
    });

    setSums(calculatedSums);
  }, [meterColumn]);

  useEffect(() => {
    // Calculate the final balance for each itemCode
    const combinedData = lubeColumn.map((lubeItem) => {
      const prevItem = lubePreviousColumn.find(
        (prev) => prev.itemCode === lubeItem.itemCode
      );
      const balanceQty = prevItem ? prevItem.balanceQty : 0;
      const saleQuantity = lubeItem.quantity;
      const saleRate = lubeItem.saleRate;
      const finalBalance = balanceQty - saleQuantity;

      return {
        itemCode: lubeItem.itemCode,
        itemName: lubeItem.itemName,
        saleRate: saleRate,
        preBalance: balanceQty,
        saleQuantity: saleQuantity,
        finalBalance: finalBalance,
      };
    });

    setLubeData(combinedData);
  }, [lubeColumn, lubePreviousColumn]);

  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  let totalLubeSum = 0;
  let totalLubeQtySum = 0;
  lubeData.forEach((ele) => {
    totalLubeSum += ele.saleRate * ele.saleQuantity;
    totalLubeQtySum += ele.saleQuantity;
  });

  let salesAmountSum = 0;
  for (const [key, value] of Object.entries(sums)) {
    salesAmountSum += value.totalAmount;
  }

  let totalcreditRateDiffSum = 0;
  rateDiffColumn.forEach((ele) => {
    totalcreditRateDiffSum += ele.credit;
  });

  let totalSalesAmountSum =
    salesAmountSum + totalLubeSum - totalcreditRateDiffSum;

  let totalCardSum = 0;
  cardColumn.forEach((ele) => {
    totalCardSum += ele.debit;
  });

  let totalCreditSaleSum = 0;
  creditSaleColumn.forEach((ele) => {
    totalCreditSaleSum += ele.debit;
  });

  let totalReceivingSum = 0;
  receiptColumn.forEach((ele) => {
    totalReceivingSum += ele.credit;
  });

  let totalPaymentSum = 0;
  paymentColumn.forEach((ele) => {
    totalPaymentSum += ele.debit;
  });

  let totalExpenseSum = 0;
  expenseColumn.forEach((ele) => {
    totalExpenseSum += ele.debit;
  });

  let totalBankSum = 0;
  bankColumn.forEach((ele) => {
    totalBankSum += ele.debit;
  });

  let totalCustomerSum = 0;
  customerStatusColumn.forEach((ele) => {
    totalCustomerSum += ele.debit;
  });

  //Credit and Card Sale total
  let netCreditSale = parseFloat(totalCreditSaleSum) + parseFloat(totalCardSum);

  // Net Sale
  let netSale = parseFloat(totalSalesAmountSum) - parseFloat(netCreditSale);

  //Total Cash
  let totalCash = 0;
  totalCash =
    parseFloat(openingCashTotal) +
    parseFloat(netSale) +
    parseFloat(totalReceivingSum);

  let cashInHand =
    parseFloat(totalCash) -
    parseFloat(totalPaymentSum) -
    parseFloat(totalExpenseSum) -
    parseFloat(totalBankSum);

  useEffect(() => {
    getName();
  });

  console.log(bulkStockStatusColumn, 'bulkkkk')
  useEffect(() => {
    function formatDate(inputDate) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formattedDate = new Date(inputDate).toLocaleDateString(
        undefined,
        options
      );
      return formattedDate;
    }

    const inputDate = meterColumn[0]?.enteredOn; // Use optional chaining to avoid errors if rightColumn[0] is undefined
    if (inputDate) {
      const formatted = formatDate(inputDate);
      setFormattedDate(formatted); // Set the formatted date in the state
    }
  }, [meterColumn]); // Listen for changes in rightColumn
  function formatCurrency(value) {
    if (value === null || value === undefined) {
      return "Rs 0.00";
    }
    return `Rs ${Number(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  function formatValue(value) {
    // Check if the value is negative
    if (value < 0) {
      // If it's negative, wrap it in parentheses
      return `(${Math.abs(value)})`;
    } else {
      // If it's positive or zero, show it as is
      return `${value}`;
    }
  }

  let totalQuantity = 0;
  let totalAmount = 0;
  // let totalDebitbankStatusColumn = 0;
  const totalDebitbankStatusColumn = bankStatusColumn.reduce(
    (acc, ele) => acc + ele.debit,
    0
  );
  const totalDebitSupplierStatusColumn = supplierStatusColumn.reduce(
    (acc, ele) => acc + ele.debit,
    0
  );
  const totalDebitCardStatusColumn = cardStatusColumn.reduce(
    (acc, ele) => acc + ele.debit,
    0
  );

  const totalDebitFuelStockStatusColumn = stockFuelStatusColumn.reduce(
    (acc, ele) => acc + ele.debit,
    0
  );

  const totalDebitLubeStockStatusColumn = stockLubeStatusColumn.reduce(
    (acc, ele) => acc + ele.debit,
    0
  );

  const totalDebitTankLorryStatusColumn = tankLorryStatusColumn.reduce(
    (acc, ele) => acc + ele.debit,
    0
  );
  const totalNetValue =
    totalDebitLubeStockStatusColumn +
    totalDebitFuelStockStatusColumn +
    totalDebitCardStatusColumn +
    totalDebitSupplierStatusColumn +
    totalDebitbankStatusColumn +
    cashInHand +
    totalDebitTankLorryStatusColumn +
    totalCustomerSum;
  const formattedTotalNetValue = totalNetValue.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  meterColumn.forEach((ele) => {
    totalQuantity += parseFloat(ele.quantity);
    totalAmount += parseFloat(ele.quantity) * parseFloat(ele.saleRate);
  });

  let itemTotals = {};

  const [itemDipTotals, setItemDipTotals] = useState({});
  useEffect(() => {
    // Initialize itemDipTotals when dailyDipColumn changes
    const totals = dailyDipColumn.reduce((acc, ele) => {
      const itemCode = ele.itemCode;
      acc[itemCode] = acc[itemCode] || {
        openingQty: 0,
        purchaseQty: 0,
        saleQty: 0,
        balanceQty: 0,
        gainQty: 0,
        closingQty: 0,
      };

      acc[itemCode].openingQty += parseFloat(ele.quantityOpening);
      acc[itemCode].purchaseQty += parseFloat(ele.quantity);
      acc[itemCode].saleQty += parseFloat(ele.balanceQty);
      acc[itemCode].balanceQty +=
        parseFloat(ele.quantityOpening) +
        parseFloat(ele.quantity) -
        parseFloat(ele.balanceQty);
      acc[itemCode].gainQty +=
        parseFloat(ele.quantityClosing) -
        (parseFloat(ele.quantityOpening) +
          parseFloat(ele.quantity) -
          parseFloat(ele.balanceQty));
      acc[itemCode].closingQty += parseFloat(ele.quantityClosing);

      return acc;
    }, {});

    setItemDipTotals(totals);
  }, [dailyDipColumn]);

  return (
    <div
      ref={ref}
      id="report-content"
      className="p-6 bg-gray-100 text-gray-800"
    >
      <div className="flex flex-col items-center justify-center padding-bottom:20px; space">
        <strong>
          {" "}
          <h1 style={{ fontSize: "30px " }}>{siteName}</h1>
        </strong>
        <strong>
          {" "}
          <h1 style={{ fontSize: "17px" }}>{siteAddress}</h1>
        </strong>
        <strong>
          <h1 style={{ fontSize: "17px" }}>
            Daily Sheet {formattedDate || ""}
          </h1>
        </strong>
      </div>

      {/* Large Tables - Each on Separate Pages */}
      <div className="page-break">
        <div className="bg-white p-4 rounded mb-8">
          <h2 className="text-2xl font-semibold mb-4">Meter Sale</h2>
          <table className="w-full border-collapse">
            {/* Table Headers */}
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">Nozel Number</th>
                <th className="border p-2">Opening</th>
                <th className="border p-2">Ending</th>
                <th className="border p-2">Quantity</th>
                <th className="border p-2">Sale Rate</th>
                <th className="border p-2">Re Tank</th>
                <th className="border p-2">Amount</th>
              </tr>
            </thead>
            {/* Table Body */}
            <tbody>
              {meterColumn.length > 0 &&
                meterColumn
                  .sort((a, b) => a.nozelOrder - b.nozelOrder)
                  .sort((a, b) => a.shift - b.shift)
                  .map((ele, i) => {
                    const rowAmount = (
                      parseFloat(ele.quantity) * parseFloat(ele.saleRate)
                    ).toFixed(2);
                    if (!itemTotals[ele.itemCode]) {
                      itemTotals[ele.itemCode] = {
                        quantity: 0,
                        amount: 0,
                      };
                    }

                    itemTotals[ele.itemCode].quantity += parseFloat(
                      ele.quantity
                    );
                    itemTotals[ele.itemCode].amount += parseFloat(rowAmount);

                    return (
                      <tr key={i} className="bg-white border-t">
                        <td className="border p-2">{ele.nozelNumber}</td>
                        <td className="border p-2">{ele.meterStarting}</td>
                        <td className="border p-2">{ele.meterEnding}</td>
                        <td className="border p-2">{ele.quantity}</td>
                        <td className="border p-2">{ele.saleRate}</td>
                        <td className="border p-2">{ele.meterCheck}</td>
                        <td className="border p-2">{rowAmount}</td>
                      </tr>
                    );
                  })}
              {Object.entries(itemTotals).map(
                ([itemCode, itemTotal], index) => (
                  <tr
                    key={index}
                    className="bg-white border-2  dark:border-gray-700"
                  >
                    <td></td>
                    <td className="px-6 py-4 text-right">
                      <strong>{`Total`}</strong>
                      {/* <strong>{`Total for Item ${itemCode}`}</strong> */}
                    </td>
                    <td className="px-6 py-4">
                      {itemCode === "1" ? <strong>PMG</strong> : null}
                      {itemCode === "2" ? <strong>HSD</strong> : null}
                      {itemCode === "3" ? <strong>HOBC</strong> : null}
                      {/* <strong>{itemTotal.openingQty.toFixed(2)}</strong> */}
                    </td>
                    <td className="px-6 py-4">
                      <strong>{itemTotal.quantity.toFixed(2)}</strong>
                    </td>
                    <td></td>
                    <td className="px-6 py-4">
                      <strong>{itemTotal.amount.toFixed(2)}</strong>
                    </td>
                  </tr>
                )
              )}
              {/* Total for all items */}
              <tr className="bg-gray-200">
                <td></td>
                <td className="text-right p-2">
                  <strong>Total</strong>
                </td>
                <td></td>
                <td className="p-2">
                  <strong>{totalQuantity.toFixed(2)}</strong>
                </td>
                <td className="p-2"></td>
                <td className="p-2">
                  <strong>
                    {totalAmount.toLocaleString("en-PK", {
                      style: "currency",
                      currency: "PKR",
                    })}
                  </strong>
                </td>
                <td className="p-2"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Next Large Table on Separate Page */}
      <div className="page-break">
        <div className="bg-white p-4 rounded mb-8">
          <h2 className="text-2xl font-semibold mb-4">Daily Dip</h2>
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-0.1">Item Code</th>
                <th className="border p-0.1">Tank Number</th>
                <th className="border p-0.1">Opening Dip</th>
                <th className="border p-0.1">Opening Qty</th>
                <th className="border p-0.1">Purchase</th>
                <th className="border p-0.1">Sale</th>
                <th className="border p-0.1">Balance</th>
                <th className="border p-0.1">Gain</th>
                <th className="border p-0.1">Closing Dip</th>
                <th className="border p-0.5">Closing Qty</th>
              </tr>
            </thead>
            <tbody>
              {dailyDipColumn.map((ele, i) => (
                <tr key={i} className="bg-white border-t">
                  <td className="border p-2">{ele.itemCode}</td>
                  <td className="border p-2">{ele.tankNumber}</td>
                  <td className="border p-2">{ele.mmOpening}</td>
                  <td className="border p-2">{ele.quantityOpening}</td>
                  <td className="border p-2">{ele.quantity}</td>
                  <td className="border p-2">{ele.balanceQty}</td>
                  <td className="border p-2">
                    {(
                      ele.quantityOpening +
                      ele.quantity -
                      ele.balanceQty
                    ).toFixed(2)}
                  </td>
                  <td className="border p-2">
                    {(
                      ele.quantityClosing -
                      (ele.quantityOpening + ele.quantity - ele.balanceQty)
                    ).toFixed(2)}
                  </td>
                  <td className="border p-2">{ele.mmClosing}</td>
                  <td className="border p-2">{ele.quantityClosing}</td>
                </tr>
              ))}

              {/* New rows for displaying item-wise totals */}
              {Object.entries(itemDipTotals).map(
                ([itemCode, itemTotal], index) => (
                  <tr key={index} className="bg-white border-t">
                    <td colSpan="3" className="px-6 py-4 text-right">
                      <strong>{`Total for Item ${itemCode}`}</strong>
                    </td>
                    <td className="px-6 py-4">
                      {itemCode === "1" ? <strong>PMG</strong> : null}
                      {itemCode === "2" ? <strong>HSD</strong> : null}
                      {itemCode === "3" ? <strong>HOBC</strong> : null}
                    </td>
                    <td className="px-6 py-4">
                      <strong>{itemTotal.purchaseQty.toFixed(2)}</strong>
                    </td>
                    <td className="px-6 py-4">
                      <strong>{itemTotal.saleQty.toFixed(2)}</strong>
                    </td>
                    <td className="px-6 py-4">
                      <strong>{itemTotal.balanceQty.toFixed(2)}</strong>
                    </td>
                    <td className="px-6 py-4">
                      <strong>{itemTotal.gainQty.toFixed(2)}</strong>
                    </td>
                    <td className="px-6 py-4">
                      <strong>{itemTotal.closingQty.toFixed(2)}</strong>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Smaller Tables in a Single Column */}
      <div className="page-break">
        {purchaseColumn.length > 0 && (
          <div className="bg-white p-4 rounded  mb-8">
            <h2 className="text-2xl font-semibold mb-4">Purchase</h2>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">V.No</th>
                  <th className="border p-2">Item Code</th>
                  <th className="border p-2">Item Name</th>
                  <th className="border p-2">Supplier Name</th>
                  <th className="border p-2">Quantity</th>
                  <th className="border p-2">Amount</th>
                </tr>
              </thead>
              <tbody>
                {purchaseColumn.map((ele, i) => (
                  <tr key={i} className="bg-white border-t">
                    <td className="border p-2">{ele.purchaseVoucherNo}</td>
                    <td className="border p-2">{ele.itemCode}</td>
                    <td className="border p-2">{ele.itemName}</td>
                    <td className="border p-2">{ele.partyName}</td>
                    <td className="border p-2">{ele.quantity}</td>
                    <td className="border p-2">
                      {parseFloat(ele.debit).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}{" "}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {lubeData.length > 0 && (
          <div className="bg-white p-4 rounded  mb-8">
            <h2 className="text-2xl font-semibold mb-4">Lube</h2>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">Item Code</th>
                  <th className="border p-2">Item Name</th>
                  <th className="border p-2">Opening Balance</th>
                  <th className="border p-2">Sale Quantity</th>
                  <th className="border p-2">Sale Rate</th>
                  <th className="border p-2">Amount</th>
                  <th className="border p-2">Closing Balance</th>
                </tr>
              </thead>
              <tbody>
                {lubeData.map((ele, i) => (
                  <tr key={i} className="bg-white border-t">
                    <td className="border p-2">{ele.itemCode}</td>
                    <td className="border p-2">{ele.itemName}</td>
                    <td className="border p-2">{ele.preBalance}</td>
                    <td className="border p-2">{ele.saleQuantity}</td>
                    <td className="border p-2">{ele.saleRate}</td>
                    <td className="border p-2">
                      {(ele.saleRate * ele.saleQuantity).toLocaleString(
                        "en-PK",
                        { style: "currency", currency: "PKR" }
                      )}
                    </td>
                    <td className="border p-2">{ele.finalBalance}</td>
                  </tr>
                ))}
                <tr className="bg-gray-200">
                  <td colSpan="5" className="text-right p-2">
                    <strong>Total</strong>
                  </td>
                  <td className="p-2">
                    <strong>
                      {totalLubeSum.toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {creditSaleRateWiseColumn.length > 0 && (
          <div className="bg-white p-4 rounded mb-8">
            <h2 className="text-2xl font-semibold mb-4">
              Credit Sale Rate Wise
            </h2>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">Item Name</th>
                  <th className="border p-2">Sale Rate</th>
                  <th className="border p-2">Quantity</th>
                  <th className="border p-2">Amount</th>
                </tr>
              </thead>
              <tbody>
                {creditSaleRateWiseColumn.map((ele, i) => (
                  <tr key={i} className="bg-white border-t">
                    <td className="border p-2">{ele.itemName}</td>
                    <td className="border p-2">{ele.saleRate}</td>
                    <td className="border p-2">{ele.quantity}</td>
                    <td className="border p-2">
                      {ele.debit.toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {paymentColumn.length > 0 && (
          <div className="bg-white p-4 rounded mb-8">
            <h2 className="text-2xl font-semibold mb-4">Payments</h2>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">V.No.</th>
                  <th className="border p-2">A/C No.</th>
                  <th className="border p-2">A/C Name</th>
                  <th className="border p-2">GL Code</th>
                  <th className="border p-2">GL Description</th>
                  <th className="border p-2">Description</th>
                  <th className="border p-2">Amount</th>
                </tr>
              </thead>
              <tbody>
                {paymentColumn.map((ele, i) => (
                  <tr key={i} className="bg-white border-t">
                    <td className="border p-2">{ele.voucherNumber}</td>
                    <td className="border p-2">{ele.partyId}</td>
                    <td className="border p-2">{ele.partyName}</td>
                    <td className="border p-2">{ele.generalLedgerCode}</td>
                    <td className="border p-2">
                      {ele.generalLedgerDescription}
                    </td>
                    <td className="border p-2">{ele.description}</td>
                    <td className="border p-2">
                      {ele.debit.toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {receiptColumn.length > 0 && (
          <div className="bg-white p-4 rounded  mb-8">
            <h2 className="text-2xl font-semibold mb-4">Receivings</h2>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">V.No.</th>
                  <th className="border p-2">A/C No.</th>
                  <th className="border p-2">A/C Name</th>
                  <th className="border p-2">GL Code</th>
                  <th className="border p-2">GL Description</th>
                  <th className="border p-2">Description</th>
                  <th className="border p-2">Amount</th>
                </tr>
              </thead>
              <tbody>
                {receiptColumn.map((ele, i) => (
                  <tr key={i} className="bg-white border-t">
                    <td className="border p-2">{ele.voucherNumber}</td>
                    <td className="border p-2">{ele.partyId}</td>
                    <td className="border p-2">{ele.partyName}</td>
                    <td className="border p-2">{ele.generalLedgerCode}</td>
                    <td className="border p-2">
                      {ele.generalLedgerDescription}
                    </td>
                    <td className="border p-2">{ele.description}</td>
                    <td className="border p-2">
                      {ele.credit.toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="page-break">
        <div className="bg-white p-4 rounded  mb-8">
          <h2 className="text-2xl font-semibold mb-4">Expenses</h2>
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">V.No.</th>
                {/* <th className="border p-2">A/C No.</th>
                <th className="border p-2">A/C Name</th> */}
                <th className="border p-2">GL Code</th>
                <th className="border p-2">GL Description</th>
                <th className="border p-2">Description</th>
                <th className="border p-2">Amount</th>
              </tr>
            </thead>
            <tbody>
              {expenseColumn.map((ele, i) => (
                <tr key={i} className="bg-white border-t">
                  <td className="border p-2">{ele.voucherNumber}</td>
                  {/* <td className="border p-2">{ele.partyId}</td>
                  <td className="border p-2">{ele.partyName}</td> */}
                  <td className="border p-2">{ele.generalLedgerCode}</td>
                  <td className="border p-2">{ele.generalLedgerDescription}</td>
                  <td className="border p-2">{ele.description}</td>
                  <td className="border p-2">
                    {ele.debit.toLocaleString("en-PK", {
                      style: "currency",
                      currency: "PKR",
                    })}
                  </td>
                </tr>
              ))}
              <tr className="bg-gray-200">
                <td colSpan="4" className="text-right p-2">
                  <strong>Total</strong>
                </td>
                <td className="p-2">
                  <strong>
                    {totalExpenseSum.toLocaleString("en-PK", {
                      style: "currency",
                      currency: "PKR",
                    })}
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Bank Table */}
      {bankColumn.length > 0 && (
        <div className="page-break">
          <div className="bg-white p-4 rounded mb-8">
            <h2 className="text-2xl font-semibold mb-4">Bank</h2>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">V.No.</th>
                  <th className="border p-2">GL Code</th>
                  <th className="border p-2">GL Description</th>
                  <th className="border p-2">Description</th>
                  <th className="border p-2">Amount</th>
                </tr>
              </thead>
              <tbody>
                {bankColumn.map((ele, i) => (
                  <tr key={i} className="bg-white border-t">
                    <td className="border p-2">{ele.voucherNumber}</td>
                    <td className="border p-2">{ele.generalLedgerCode}</td>
                    <td className="border p-2">
                      {ele.generalLedgerDescription}
                    </td>
                    <td className="border p-2">{ele.description}</td>
                    {/* <td className="border p-2">{ele.debit}</td> */}
                    <td className="border p-2">
                      {ele.debit.toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                ))}
                <tr className="bg-gray-200">
                  <td colSpan="4" className="text-right p-2">
                    <strong>Total</strong>
                  </td>
                  <td className="p-2">
                    <strong>
                      {totalBankSum.toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Supplier Payments Table */}
      {supplierColumn.length > 0 && (
        <div className="page-break">
          <div className="bg-white p-4 rounded  mb-8">
            <h2 className="text-2xl font-semibold mb-4">Supplier Payments</h2>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">V.No.</th>
                  <th className="border p-2">Party Id</th>
                  <th className="border p-2">Party Name</th>
                  <th className="border p-2">Description</th>
                  <th className="border p-2">Amount</th>
                </tr>
              </thead>
              <tbody>
                {supplierColumn.map((ele, i) => (
                  <tr key={i} className="bg-white border-t">
                    <td className="border p-2">{ele.voucherNumber}</td>
                    <td className="border p-2">{ele.partyId}</td>
                    <td className="border p-2">{ele.partyName}</td>
                    <td className="border p-2">{ele.description}</td>
                    <td className="border p-2">
                      {ele.debit.toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div className="page-break">
        <div className="flex flex-row">
          <div className="w-1/2 pr-2">
            <div className="bg-white p-4 rounded mb-8">
              <h2 className="text-2xl font-semibold mb-4">Sales</h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2">Item Name</th>
                    <th className="border p-2">Quantity</th>
                    <th className="border p-2">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(sums).map(([key, value]) => (
                    <tr key={key} className="bg-white border-t">
                      <td className="border p-2">{value.itemName}</td>
                      <td className="border p-2">
                        {value.totalQuantity.toFixed(2)}
                      </td>
                      <td className="border p-2">
                        {value.totalAmount.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </td>
                    </tr>
                  ))}

                  <tr className="bg-white border-t">
                    <td className="border p-2">Lube</td>
                    <td className="border p-2">{totalLubeQtySum.toFixed(2)}</td>
                    <td className="border p-2">{totalLubeSum.toFixed(2)}</td>
                  </tr>
                  {rateDiffColumn.length > 0 &&
                    rateDiffColumn.map((ele, i) => {
                      return (
                        <tr key={i} className="bg-white border-t">
                          <td className="border p-2">Rate Diff</td>
                          <td className="border p-2"></td>
                          <td className="border p-2">{ele.credit}</td>
                        </tr>
                      );
                    })}

                  <tr className="bg-gray-200">
                    <td className="text-right p-2">
                      <strong>Total</strong>
                    </td>
                    <td className="p-2"></td>
                    <td className="p-2">
                      <strong>
                        {totalSalesAmountSum.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-1/2 pl-2">
            <div className="bg-white p-4 rounded mb-8">
              <h2 className="text-2xl font-semibold mb-4">Cash Summary</h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2">Description</th>
                    <th className="border p-2">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-white border-t">
                    <td className="border p-2">
                      <strong>Opening Cash</strong>
                    </td>
                    <td className="border p-2">
                      {parseFloat(openingCashTotal).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                  <tr className="bg-white border-t">
                    <td className="border p-2">
                      <strong>Net Sales</strong>
                    </td>
                    <td className="border p-2">
                      {parseFloat(netSale).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                  <tr className="bg-white border-t">
                    <td className="border p-2">
                      <strong>Receivings</strong>
                    </td>
                    <td className="border p-2">
                      {parseFloat(totalReceivingSum).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                  <tr className="bg-white border-t">
                    <td className="border p-2">
                      <strong>Total Cash</strong>
                    </td>
                    <td className="border p-2">
                      {parseFloat(totalCash).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                  <tr className="bg-white border-t">
                    <td className="border p-2">
                      <strong>Expense</strong>
                    </td>
                    <td className="border p-2">
                      {parseFloat(totalExpenseSum).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                  <tr className="bg-white border-t">
                    <td className="border p-2">
                      <strong>Bank Deposit</strong>
                    </td>
                    <td className="border p-2">
                      {parseFloat(totalBankSum).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                  <tr className="bg-white border-t">
                    <td className="border p-2">
                      <strong>Payments</strong>
                    </td>
                    <td className="border p-2">
                      {parseFloat(totalPaymentSum).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                  <tr className="bg-white border-t">
                    <td className="border p-2">
                      <strong>Cash In Hand</strong>
                    </td>
                    <td className="border p-2">
                      {parseFloat(cashInHand).toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="page-break">
        <div className="flex flex-row">
          <div className="w-1/2 pr-2">
            <div className="bg-white p-4 rounded mb-8">
              <h2 className="text-2xl font-semibold mb-4">Cards</h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2">ID</th>
                    <th className="border p-2">Name</th>
                    <th className="border p-2">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {cardColumn.map((ele, i) => (
                    <tr key={i} className="bg-white border-t">
                      <td className="border p-2">{ele.partyId}</td>
                      <td className="border p-2">{ele.partyName}</td>
                      <td className="border p-2">
                        {ele.debit.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-200">
                    <td className="text-right p-2" colSpan="2">
                      <strong>Total</strong>
                    </td>
                    <td className="p-2">
                      <strong>
                        {totalCardSum.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-1/2 pl-2">
            <div className="bg-white p-4 rounded mb-8">
              <h2 className="text-2xl font-semibold mb-4">Credits</h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2">Type</th>
                    <th className="border p-2">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-white border-t">
                    <td className="border p-2">Credit Cards</td>
                    <td className="border p-2">
                      {totalCardSum.toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                  <tr className="bg-white border-t">
                    <td className="border p-2">Credit Sale</td>
                    <td className="border p-2">
                      {totalCreditSaleSum.toLocaleString("en-PK", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </td>
                  </tr>
                  <tr className="bg-gray-200">
                    <td className="text-right p-2">
                      <strong>Total</strong>
                    </td>
                    <td className="p-2">
                      <strong>
                        {netCreditSale.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="page-break">
        <div className="flex flex-row">
          <div className="w-1/2 pr-2">
            <div className="bg-white p-4 rounded mb-8">
              <h2 className="text-2xl font-semibold mb-4">Physical Stock Status</h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2">Item Name</th>
                    <th className="border p-2">Quantity</th>
                    <th className="border p-2">Rate</th>
                    <th className="border p-2">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {stockFuelStatusColumn.map((ele, i) => (
                    <tr key={i} className="bg-white border-t">
                      <td className="border p-2">{ele.itemName}</td>
                      <td className="border p-2">{ele.quantity}</td>
                      <td className="border p-2">{ele.purchaseRate}</td>
                      <td className="border p-2">
                        {ele.debit.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-200">
                    <td className="text-right p-2" colSpan="3">
                      <strong>Fuel Total</strong>
                    </td>
                    <td className="p-2">
                      <strong>
                        {totalDebitFuelStockStatusColumn.toLocaleString(
                          "en-PK",
                          { style: "currency", currency: "PKR" }
                        )}
                      </strong>
                    </td>
                  </tr>
                  <tr className="bg-gray-200">
                    <td className="text-right p-2" colSpan="3">
                      <strong>Lubricants Total</strong>
                    </td>
                    <td className="p-2">
                      <strong>
                        {totalDebitLubeStockStatusColumn.toLocaleString(
                          "en-PK",
                          { style: "currency", currency: "PKR" }
                        )}
                      </strong>
                    </td>
                  </tr>
                  <tr className="bg-gray-200">
                    <td className="text-right p-2" colSpan="3">
                      <strong>Total</strong>
                    </td>
                    <td className="p-2">
                      <strong>
                        {(
                          totalDebitLubeStockStatusColumn +
                          totalDebitFuelStockStatusColumn
                        ).toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {tankLorryStatusColumn.length > 0 && (
            <div className="w-1/2 pl-2">
              <div className="bg-white p-4 rounded mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  Tank Lorry Status
                </h2>
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="border p-2">Description</th>
                      <th className="border p-2">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tankLorryStatusColumn.map((ele, i) => (
                      <tr key={i} className="bg-white border-t">
                        <td className="border p-2">{ele.itemDescription}</td>
                        <td className="border p-2">
                          {ele.debit.toLocaleString("en-PK", {
                            style: "currency",
                            currency: "PKR",
                          })}
                        </td>
                      </tr>
                    ))}
                    <tr className="bg-gray-200">
                      <td className="text-right p-2">
                        <strong>Total</strong>
                      </td>
                      <td className="p-2">
                        <strong>
                          {totalDebitTankLorryStatusColumn.toLocaleString(
                            "en-PK",
                            { style: "currency", currency: "PKR" }
                          )}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {tankLorryStatusColumn.length > 0 && (   <div className="page-break">
          <div className="w-1/2 pr-2">
            <div className="bg-white p-4 rounded mb-8">
              <h2 className="text-2xl font-semibold mb-4">Bulk Stock Status</h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2">Item Name</th>
                    <th className="border p-2">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {bulkStockStatusColumn.map((ele, i) => (
                    <tr key={i} className="bg-white border-t">
                      <td className="border p-2">{ele.itemDescription}</td>
                      <td className="border p-2">{ele.mmClosing}</td>
                    </tr>
                  ))}
                  {/* <tr className="bg-gray-200">
                    <td className="text-right p-2" colSpan="3">
                      <strong>Fuel Total</strong>
                    </td>
                    <td className="p-2">
                      <strong>
                        {totalDebitFuelStockStatusColumn.toLocaleString(
                          "en-PK",
                          { style: "currency", currency: "PKR" }
                        )}
                      </strong>
                    </td>
                  </tr>
                  <tr className="bg-gray-200">
                    <td className="text-right p-2" colSpan="3">
                      <strong>Lubricants Total</strong>
                    </td>
                    <td className="p-2">
                      <strong>
                        {totalDebitLubeStockStatusColumn.toLocaleString(
                          "en-PK",
                          { style: "currency", currency: "PKR" }
                        )}
                      </strong>
                    </td>
                  </tr>
                  <tr className="bg-gray-200">
                    <td className="text-right p-2" colSpan="3">
                      <strong>Total</strong>
                    </td>
                    <td className="p-2">
                      <strong>
                        {(
                          totalDebitLubeStockStatusColumn +
                          totalDebitFuelStockStatusColumn
                        ).toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </strong>
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>)}
      

      <div className="page-break">
        <div className="flex flex-row">
          <div className="w-1/2 pr-2">
            <div className="bg-white p-4 rounded mb-8">
              <h2 className="text-2xl font-semibold mb-4">Bank Status</h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2">Name</th>
                    <th className="border p-2">Receivable</th>
                    <th className="border p-2">Payable</th>
                  </tr>
                </thead>
                <tbody>
                  {bankStatusColumn.map((ele, i) => (
                    <tr key={i} className="bg-white border-t">
                      <td className="border p-2">
                        {ele.generalLedgerDescription}
                      </td>
                      <td className="border p-2">
                        {ele.debit >= 0
                          ? ele.debit.toLocaleString("en-PK", {
                              style: "currency",
                              currency: "PKR",
                            })
                          : 0}
                      </td>
                      <td className="border p-2">
                        {ele.debit < 0
                          ? (-ele.debit).toLocaleString("en-PK", {
                              style: "currency",
                              currency: "PKR",
                            })
                          : 0}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-200">
                    <td className="text-right p-2">
                      <strong>Total</strong>
                    </td>
                    <td className="p-2"></td>
                    <td className="p-2">
                      <strong>
                        {totalDebitbankStatusColumn.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-1/2 pl-2">
            <div className="bg-white p-4 rounded mb-8">
              <h2 className="text-2xl font-semibold mb-4">Card Status</h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2 text-small">Name</th>
                    <th className="border p-2 text-small">Receivable</th>
                    <th className="border p-2 text-small">Payable</th>
                  </tr>
                </thead>
                <tbody>
                  {cardStatusColumn.map((ele, i) => (
                    <tr key={i} className="bg-white border-t">
                      <td className="border p-2">{ele.partyName}</td>
                      <td className="border p-2">
                        {ele.debit >= 0
                          ? ele.debit.toLocaleString("en-PK", {
                              style: "currency",
                              currency: "PKR",
                            })
                          : 0}
                      </td>
                      <td className="border p-2">
                        {ele.debit < 0
                          ? (-ele.debit).toLocaleString("en-PK", {
                              style: "currency",
                              currency: "PKR",
                            })
                          : 0}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-200">
                    <td className="text-right p-2">
                      <strong>Total</strong>
                    </td>
                    <td className="p-2"></td>
                    <td className="p-2">
                      <strong>
                        {totalDebitCardStatusColumn.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="page-break">
        <div className="flex flex-col">
          <div className="w-1/2 pr-2">
            <div className="bg-white p-4 rounded mb-8 w-full">
              <h2 className="text-2xl font-semibold mb-4">Supplier Status</h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-2 text-small">Name</th>
                    <th className="border p-2 text-small">Receivable</th>
                    <th className="border p-2 text-small">Payable</th>
                  </tr>
                </thead>
                <tbody>
                  {supplierStatusColumn.map((ele, i) => (
                    <tr key={i} className="bg-white border-t">
                      <td className="border p-2">{ele.partyName}</td>
                      <td className="border p-2">
                        {ele.debit >= 0
                          ? ele.debit.toLocaleString("en-PK", {
                              style: "currency",
                              currency: "PKR",
                            })
                          : 0}
                      </td>
                      <td className="border p-2">
                        {ele.debit < 0
                          ? (-ele.debit).toLocaleString("en-PK", {
                              style: "currency",
                              currency: "PKR",
                            })
                          : 0}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-200">
                    <td className="text-right p-2">
                      <strong>Total</strong>
                    </td>
                    <td className="p-2"></td>
                    <td className="p-2">
                      <strong>
                        {totalDebitSupplierStatusColumn.toLocaleString(
                          "en-PK",
                          { style: "currency", currency: "PKR" }
                        )}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="page-break">
        <div className="flex flex-col">
          {(creditSaleColumn.length > 0 || customerStatusColumn.length > 0) && (
            <div className="bg-white p-4 rounded mb-8 w-full">
              <h2 className="text-2xl font-semibold mb-6">
                Credit Sale & Customer Status
              </h2>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border p-4">A/C Name</th>
                    <th className="border p-4">To Day</th>
                    <th className="border p-4">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {creditSaleColumn.map((creditSale, i) => {
                    const customerStatus = customerStatusColumn.find(
                      (customer) => customer.partyId === creditSale.partyId
                    );
                    return (
                      <tr key={i} className="bg-white border-t">
                        <td className="border p-4 ">{creditSale.partyName}</td>
                        <td className="border p-4 ">
                          {creditSale.debit.toLocaleString("en-PK", {
                            style: "currency",
                            currency: "PKR",
                          })}
                        </td>
                        <td className="border p-4 ">
                          {customerStatus
                            ? customerStatus.debit.toLocaleString("en-PK", {
                                style: "currency",
                                currency: "PKR",
                              })
                            : ""}
                        </td>
                      </tr>
                    );
                  })}

                  {customerStatusColumn
                    .filter(
                      (customer) =>
                        !creditSaleColumn.some(
                          (creditSale) =>
                            creditSale.partyId === customer.partyId
                        )
                    )
                    .map((customerStatus, i) => (
                      <tr key={i} className="bg-white border-t">
                        <td className="border p-4 ">
                          {customerStatus.partyName}
                        </td>
                        <td className="border p-4 "></td>
                        <td className="border p-4 ">
                          {customerStatus.debit < 0
                            ? `(${Math.abs(customerStatus.debit).toLocaleString(
                                "en-PK",
                                { style: "currency", currency: "PKR" }
                              )})`
                            : customerStatus.debit.toLocaleString("en-PK", {
                                style: "currency",
                                currency: "PKR",
                              })}
                        </td>
                      </tr>
                    ))}

                  <tr className="bg-gray-200">
                    <td className="p-4">
                      <strong>Total</strong>
                    </td>
                    <td className="p-4">
                      <strong>
                        {totalCreditSaleSum.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </strong>
                    </td>
                    <td className="p-4">
                      <strong>
                        {totalCustomerSum.toLocaleString("en-PK", {
                          style: "currency",
                          currency: "PKR",
                        })}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {/* {(
  creditSaleColumn.length > 0 ||
  customerStatusColumn.length > 0 ||
  paymentColumn.length > 0
) && (
  <div className="bg-white p-4 rounded mb-8 w-full">
    <h2 className="text-2xl font-semibold mb-6">
      Credit Sale & Customer Status
    </h2>

    <table className="w-full border-collapse">
      <thead>
        <tr className="bg-gray-200">
          <th className="border p-4">A/C Name</th>
          <th className="border p-4">To Day</th>
          <th className="border p-4">Balance</th>
        </tr>
      </thead>

      <tbody>

       

        {creditSaleColumn.map((creditSale, i) => {

          const customerStatus = customerStatusColumn.find(
            (customer) =>
              customer.partyId === creditSale.partyId
          );

          const customerPayments = paymentColumn.filter(
            (payment) =>
              payment.partyId === creditSale.partyId &&
              payment.generalLedgerDescription === "Credit Customers"
          );

          const paymentDebit = customerPayments.reduce(
            (total, payment) =>
              total + Number(payment.debit || 0),
            0
          );

          const todayAmount =
            Number(creditSale.debit || 0) + paymentDebit;

          return (
            <tr key={`credit-${i}`} className="bg-white border-t">

              <td className="border p-4">
                {creditSale.partyName}
              </td>

              <td className="border p-4">
                {todayAmount.toLocaleString("en-PK", {
                  style: "currency",
                  currency: "PKR",
                })}
              </td>

              <td className="border p-4">
                {customerStatus
                  ? customerStatus.debit.toLocaleString("en-PK", {
                      style: "currency",
                      currency: "PKR",
                    })
                  : ""}
              </td>

            </tr>
          );
        })}


       

        {paymentColumn
          .filter(
            (payment) =>
              payment.partyId &&
              payment.generalLedgerDescription === "Credit Customers" &&
              !creditSaleColumn.some(
                (creditSale) =>
                  creditSale.partyId === payment.partyId
              )
          )
          .map((payment, i) => {

            const customerStatus = customerStatusColumn.find(
              (customer) =>
                customer.partyId === payment.partyId
            );

            return (
              <tr
                key={`payment-${i}`}
                className="bg-white border-t"
              >

                <td className="border p-4">
                  {payment.partyName}
                </td>

                <td className="border p-4">
                  {Number(payment.debit || 0).toLocaleString(
                    "en-PK",
                    {
                      style: "currency",
                      currency: "PKR",
                    }
                  )}
                </td>

                <td className="border p-4">
                  {customerStatus
                    ? customerStatus.debit.toLocaleString(
                        "en-PK",
                        {
                          style: "currency",
                          currency: "PKR",
                        }
                      )
                    : ""}
                </td>

              </tr>
            );
          })}


       
        {customerStatusColumn
          .filter(
            (customer) =>
              !creditSaleColumn.some(
                (creditSale) =>
                  creditSale.partyId === customer.partyId
              ) &&
              !paymentColumn.some(
                (payment) =>
                  payment.partyId === customer.partyId
              )
          )
          .map((customerStatus, i) => (
            <tr
              key={`status-${i}`}
              className="bg-white border-t"
            >

              <td className="border p-4">
                {customerStatus.partyName}
              </td>

              <td className="border p-4"></td>

              <td className="border p-4">
                {customerStatus.debit < 0
                  ? `(${Math.abs(
                      customerStatus.debit
                    ).toLocaleString("en-PK", {
                      style: "currency",
                      currency: "PKR",
                    })})`
                  : customerStatus.debit.toLocaleString(
                      "en-PK",
                      {
                        style: "currency",
                        currency: "PKR",
                      }
                    )}
              </td>

            </tr>
          ))}


       
        <tr className="bg-gray-200">

          <td className="p-4">
            <strong>Total</strong>
          </td>

          <td className="p-4">
            <strong>
              {totalCreditSaleSum.toLocaleString("en-PK", {
                style: "currency",
                currency: "PKR",
              })}
            </strong>
          </td>

          <td className="p-4">
            <strong>
              {totalCustomerSum.toLocaleString("en-PK", {
                style: "currency",
                currency: "PKR",
              })}
            </strong>
          </td>

        </tr>

      </tbody>
    </table>
  </div>
)} */}
        </div>
      </div>

      <div className="page-break">
        <div className="flex flex-col">
          <div className="bg-white p-4 rounded mb-8">
            <h2 className="text-2xl font-semibold mb-4">Net Value</h2>
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-2">Description</th>
                  <th className="border p-2">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-white border-t">
                  <td className="border p-2">
                    <strong>Total Net Value</strong>
                  </td>
                  <td className="border p-2">
                    <strong>{formattedTotalNetValue}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
});
